import React from 'react'
import { WizButton } from 'wiz-components';
//  班级类型
const typeArr = ['线下班级', '线上班级']

// 状态
const statusArr = ['未输入成绩', '通过', '未通过', '无成绩']
export default (handleRow,processContentState) => [
  {
    title: '岗位',
    dataIndex: 'positionName',
    key: 'positionName',
    align: 'center',
    width: 200,
    render: (text, row, index) => {
      const obj = {
        children: text,
        props: {
          rowSpan: row.rowSpan
        },
      }
      return obj
    }
  },
  {
    title: '姓名',
    dataIndex: 'fullName',
    key: 'fullName',
    align: 'center',
    width: 150,
    render: (text, row, index) => {
      const obj = {
        children: text,
        props: {
          rowSpan: row.rowSpan
        },
      }
      return obj
    }
  },
  {
    title: '开班时间',
    dataIndex: 'classInfoStartDate',
    key: 'classInfoStartDate',
    align: 'center',
    width: 200,
  },
  {
    title: '班级名称',
    dataIndex: 'classInfoName',
    key: 'classInfoName',
    align: 'center',
    width: 200
  },
  {
    title: '班级类型',
    dataIndex: 'classInfoType',
    key: 'classInfoType',
    align: 'center',
    width: 200,
    render: (text) => (text || text === 0 ? typeArr[text] : null)
  },
  {
    title: '所属课程',
    dataIndex: 'programName',
    key: 'programName',
    align: 'center',
    width: 250,
  },
  {
    title: '状态',
    dataIndex: 'classResultStatus',
    key: 'classResultStatus',
    align: 'center',
    width: 120,
    render: (text) => (text || text === 0 ? statusArr[text] : null)
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    align: 'center',
    width: 100,
    render: (text, row) => {
      let { classResultStatus } = row
      // 未输入成绩 状态下才显示填写
      return (
        text ? <WizButton type='link' onClick={() => handleRow(3, row)}>
          查看
        </WizButton> : processContentState !== 1 && classResultStatus !== 1 ? <WizButton type='link' onClick={() => handleRow(2, row)}>
          填写
        </WizButton> : null

      )
    }
  },
  {
    title: '操作',
    name: 'operation',
    dataIndex: 'operation',
    align: 'center',
    width: 120,
    render: (text, row, index) => {
      const obj = {
        children: <WizButton type='link' disabled={!row.personId} onClick={() => handleRow(1, row)}>{'报班情况'}</WizButton>,
        props: {
          rowSpan: row.rowSpan
        },
      }
      return obj
    }
  }
];
